// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N2Cn18aVX4aj9E_f {
  width: 320px;
  height: 200px;
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfe3e7;
  padding: 32px 24px 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.veVgnng0_fwicl0N {
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
  color: #333333;
  margin-bottom: 8px;
}
.lvF8iSuzvEwhT_ZK {
  font-size: 14px;
  line-height: 22px;
  color: #666666;
  margin-bottom: 25px;
}
.lvF8iSuzvEwhT_ZK > a {
  color: #0095fc;
}
.B4PUYe_ltxony3_K {
  width: 120px;
  line-height: 32px;
  border-radius: 18.5px;
  background: #0095fc;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  margin: 0 auto;
  cursor: pointer;
  user-select: none;
}
.lSkwvKVYxp0OYyip {
  position: absolute;
  width: 12px;
  height: 12px;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.lSkwvKVYxp0OYyip:hover {
  color: #0095fc;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/NoAccess/index.modules.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AACF;AACA;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;AACA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AACF;AALA;EAMI,cAAA;AAEJ;AACA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACF;AACA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AACJ;AAAI;EACI,cAAA;AAER","sourcesContent":[".AccessModal {\n  width: 320px;\n  height: 200px;\n  border-radius: 8px;\n  background: #ffffff;\n  box-sizing: border-box;\n  border: 1px solid #dfe3e7;\n  padding: 32px 24px 16px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.modalTit {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 22px;\n  text-align: center;\n  color: #333333;\n  margin-bottom: 8px;\n}\n.modalInfo {\n  font-size: 14px;\n  line-height: 22px;\n  color: #666666;\n  margin-bottom: 25px;\n  > a {\n    color: #0095fc;\n  }\n}\n.modalBtn {\n  width: 120px;\n  line-height: 32px;\n  border-radius: 18.5px;\n  background: #0095fc;\n  text-align: center;\n  color: #ffffff;\n  font-size: 14px;\n  margin: 0 auto;\n  cursor: pointer;\n  user-select: none;\n}\n.close {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    right: 10px;\n    top: 10px;\n    cursor: pointer;\n    &:hover {\n        color: #0095fc;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"AccessModal": `N2Cn18aVX4aj9E_f`,
	"modalTit": `veVgnng0_fwicl0N`,
	"modalInfo": `lvF8iSuzvEwhT_ZK`,
	"modalBtn": `B4PUYe_ltxony3_K`,
	"close": `lSkwvKVYxp0OYyip`
};
export default ___CSS_LOADER_EXPORT___;
